import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timestamp'
})
export class TimestampPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    // Value is not a number
    if (!value) {
      return '-';
    }

    // Get date
    const date = new Date(value);

    if (!date.getTime()) {
      return '-';
    }

    // Format date
    return `${this.formatDay(date)}.${this.formatMonth(date)}.${date.getFullYear()} ${this.formatHour(date)}:${this.formatMinute(date)}`;
  }

  formatDay(date: Date): string {
    const day = String(date.getUTCDate());

    if (day.length === 1) {
      return '0' + day;
    }

    return day;
  }

  formatMonth(date: Date): string {
    const month = String(date.getUTCMonth() + 1);

    if (month.length === 1) {
      return '0' + month;
    }

    return month;
  }

  formatHour(date: Date) {
    const hour = String(date.getHours());

    if (hour.length === 1) {
      return '0' + hour;
    }

    return hour;
  }

  formatMinute(date: Date) {
    const minute = String(date.getMinutes());

    if (minute.length === 1) {
      return '0' + minute;
    }

    return minute;
  }

}
